import React from "react";
import { Modal, Button, Form, InputGroup } from "react-bootstrap";

import {
  ModalBodyBlack,
  ModalFooterBlack,
  ModalHeaderBlack,
  MyModal,
  RadConnStyle as radStyle,
} from "../../../features/RadConnStyle";
import axios from "axios";
import { HttpJsonHeader } from "../../../features/Environments";
import { LabelBlack, FormControlBlack } from "../../components/PageParams";

export default function CompanyPopup({ props }) {
  let rowId = props.fields == null ? -1 : props.fields.compid;

  const submit = (evt) => {
    let data = {
      CompId: rowId,
      CompCode: evt.target.oCompCode.value,
      CompNameTh: evt.target.oCompNameTh.value,
      CompNameEn: evt.target.oCompNameEn.value,
      CompAddrTh: evt.target.oCompAddrTh.value,
      CompAddrTh2: evt.target.oCompAddrTh2.value,
      CompAddrEn: evt.target.oCompAddrEn.value,
      CompAddrEn2: evt.target.oCompAddrEn2.value,
      CompShortName: evt.target.oCompShortName.value,
      Phone: evt.target.oPhone.value,
      Email: evt.target.oEmail.value,
      Taxid: evt.target.oTaxId.value,
      updateby: props.user.userid,
    };

    if (rowId < 0) {
      data = { ...data, createby: props.user.userid };
    }

    evt.preventDefault();
    axios
      .post(
        process.env.REACT_APP_API + "api/company/update",
        data,
        HttpJsonHeader
      )
      .then((res) => {
        props.setUpdate(true);
        props.hidePopup();
      })
      .catch((err) => alert(err));
  };

  return (
    <MyModal
      show={props.show}
      size="lg"
      onHide={props.hidePopup}
      backdrop={false}
      centered
    >
      <ModalHeaderBlack closeButton>
        <Modal.Title>เพิ่มแก้ไข-กิจการ</Modal.Title>
      </ModalHeaderBlack>

      <ModalBodyBlack style={radStyle.modalBlackBody}>
        <Form id="form1" onSubmit={submit} className="formX1">
          <InputGroup className="mb-1">
            <LabelBlack> รหัสกิจการ</LabelBlack>
            <FormControlBlack
              aria-label="รหัส"
              name="oCompCode"
              required
              defaultValue={props.fields == null ? "" : props.fields.compcode}
              placeholder="รหัสกิจการ .. "
            />
          </InputGroup>

          <InputGroup className="mb-1">
            <LabelBlack>ชื่อกิจการ(ไทย)</LabelBlack>
            <FormControlBlack
              aria-label="ภาษาไทย"
              name="oCompNameTh"
              defaultValue={
                props.fields == null ? "" : props.fields.compname_th
              }
              placeholder="ชื่อภาษาไทย .. "
            />
          </InputGroup>

          <InputGroup className="mb-1">
            <LabelBlack>ชื่อกิจการ(Eng)</LabelBlack>
            <FormControlBlack
              aria-label="ชื่อกิจการ(Eng)"
              name="oCompNameEn"
              defaultValue={
                props.fields == null ? "" : props.fields.compname_en
              }
              placeholder="English name .. "
            />
          </InputGroup>

          <InputGroup className="mb-1">
            <LabelBlack>ชื่อสั้น</LabelBlack>
            <FormControlBlack
              aria-label=""
              name="oCompShortName"
              defaultValue={props.fields == null ? "" : props.fields.compshort}
              placeholder="ชื่อภาษาไทย .. "
            />
          </InputGroup>

          <InputGroup className="mb-1">
            <LabelBlack>โทรศัพท์/Email</LabelBlack>
            <FormControlBlack
              aria-label=""
              name="oPhone"
              required
              defaultValue={props.fields == null ? "" : props.fields.phone}
              placeholder="โทรศัพท์ .. "
            />
            <FormControlBlack
              aria-label=""
              name="oEmail"
              required
              defaultValue={props.fields == null ? "" : props.fields.email}
              placeholder="Email .. "
            />
          </InputGroup>

          <InputGroup className="mb-1">
            <LabelBlack>เลขผู้เสียภาษี</LabelBlack>
            <FormControlBlack
              aria-label=""
              name="oTaxId"
              required
              defaultValue={props.fields == null ? "" : props.fields.taxid}
              placeholder="เลขที่ผู้เสียภาษีอากร 10 หลัก.. "
            />
          </InputGroup>

          <InputGroup className="mb-0">
            <LabelBlack className="formLabel">ที่อยู่ (ไทย)</LabelBlack>
            <FormControlBlack
              type="text"
              name="oCompAddrTh"
              defaultValue={
                props.fields == null ? "" : props.fields.compaddr_th
              }
              placeholder="เลขที่/ซอย/ถนน/ตำบล...."
            />
          </InputGroup>

          <InputGroup className="mb-1">
            <LabelBlack className="formLabel"></LabelBlack>
            <FormControlBlack
              type="text"
              name="oCompAddrTh2"
              defaultValue={
                props.fields == null ? "" : props.fields.compaddr2_th
              }
              placeholder="อำเภอ/จังหวัด ..."
            />
          </InputGroup>

          <InputGroup>
            <LabelBlack className="formLabel">ที่อยู่ (English)</LabelBlack>
            <FormControlBlack
              type="text"
              name="oCompAddrEn"
              defaultValue={
                props.fields == null ? "" : props.fields.compaddr_en
              }
              placeholder="...."
            />
          </InputGroup>

          <InputGroup>
            <LabelBlack className="formLabel"></LabelBlack>
            <FormControlBlack
              type="text"
              name="oCompAddrEn2"
              defaultValue={
                props.fields == null ? "" : props.fields.compaddr2_en
              }
              placeholder="..."
            />
          </InputGroup>
        </Form>
      </ModalBodyBlack>

      <ModalFooterBlack style={radStyle.modalFooterBlack}>
        <Button variant="primary" type="submit" form="form1">
          Save changes
        </Button>
        <Button variant="danger" onClick={props.hidePopup}>
          Close
        </Button>
      </ModalFooterBlack>
    </MyModal>
  );
}
